import React, { useEffect } from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import { Box, Grid } from '@material-ui/core'
import clsx from 'clsx'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import PageData from '@v4/utils/data/PageData'
import useStyles from './Fallback.styled'

const Fallback = () => {
	const pageType = PageBuilderSelector.useType()
	const isTypeResultPdf = PageData.isTypeResultPdf(pageType)
	const classes = useStyles({
		isTypeResultPdf,
	})
	const columnSize = isTypeResultPdf ? 12 : 6

	useEffect(() => {
		return () => {
			const event = new Event('lazy-loaded')

			window.dispatchEvent(event)
		}
	}, [])

	return (
		<div className={classes.root}>
			<Grid container spacing={8} alignItems="center">
				<Grid item lg={columnSize} md={columnSize} sm={columnSize} xs={12}>
					<div>
						<Box>
							<Skeleton
								className={classes.skeleton}
								animation="wave"
								variant="rect"
								width="50%"
								height="2.5rem"
							/>
						</Box>
						<Box mt={3}>
							<Skeleton className={classes.skeleton} animation="wave" variant="rect" height="1.5rem" />
						</Box>
						<Box mt={3}>
							<Skeleton className={classes.skeleton} animation="wave" variant="rect" height="1rem" />
						</Box>
						<Box mt={2}>
							<Skeleton className={classes.skeleton} animation="wave" variant="rect" height="1rem" />
						</Box>
						<Box mt={2}>
							<Skeleton
								className={classes.skeleton}
								animation="wave"
								variant="rect"
								width="50%"
								height="1rem"
							/>
						</Box>
						{!isTypeResultPdf && (
							<>
								<Box mt={3}>
									<Skeleton
										className={classes.skeleton}
										animation="wave"
										variant="rect"
										height="1rem"
									/>
								</Box>
								<Box mt={2}>
									<Skeleton
										className={classes.skeleton}
										animation="wave"
										variant="rect"
										width="50%"
										height="1rem"
									/>
								</Box>
								<Box mt={3}>
									<Skeleton
										className={classes.skeleton}
										animation="wave"
										variant="rect"
										width="25%"
										height="2.5rem"
									/>
								</Box>
							</>
						)}
					</div>
				</Grid>
				<Grid item lg={columnSize} md={columnSize} sm={columnSize} xs={12}>
					<div className={classes.rectWrap}>
						<Skeleton animation="wave" className={clsx(classes.skeleton, classes.rect)} variant="rect" />
					</div>
				</Grid>
			</Grid>
		</div>
	)
}

export default Fallback
